<!-- <section id="st-intro">
    <div class="featured-slider" data-display="1,1,1,1" data-dot="on" data-nav="on" data-number="on" data-autoplay="on" data-interval="5000">
        <div class="slider-content"             >
            <div class="slider-wrapper row container">
                <ng-container *ngFor="let item of contentsBanner;">
                    <div class="col-12 slide item" style="width: 1919px;">
                        <a routerLink="{{ item.linkInfo }}">
                            <img src="{{ urlWownet + item.filePath + item.fileName }}" alt="{{ item.fileName }}" />
                        </a>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section> -->

<!-- new style -->

<div class="mainSlideWrap">
  <div class="mainVisual">
    <div class="swiper-container">
      <ul class="swiper-wrapper">
        <li class="swiper-slide " *ngFor="let item of contentsBanner; let i = index">
          <a routerLink="{{ item.linkInfo }}">
            <div>
              <img src="{{ item.pathUrl  }}"  alt="{{ item.fileName }}" >
            </div>
          </a>
        </li>
      </ul>
      <!-- <div class="swiper-control">
        <ul class="swiper-pagination">
        </ul>
      </div> -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </div>
</div>
